import { render, staticRenderFns } from "./ResumenMedios.vue?vue&type=template&id=2054420a&scoped=true"
import script from "./ResumenMedios.vue?vue&type=script&lang=js"
export * from "./ResumenMedios.vue?vue&type=script&lang=js"
import style0 from "./ResumenMedios.vue?vue&type=style&index=0&id=2054420a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2054420a",
  null
  
)

export default component.exports